export default __webpack_public_path__ + "static/media/second-bg.02d23508.svg";